import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const StatCard = ({ label, value, gridColumn, icon, color = '#4E83BD' }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        padding: { xs: '10px 12px', sm: '12px 14px', md: '16px 20px' },
        borderRadius: '8px',
        textAlign: 'center',
        gridColumn: gridColumn,
        backgroundColor: '#FFFFFF',
        border: `1px solid #ECF0F1`,
        // Fill the flex grid cell on all screen sizes
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        borderColor: color,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: color,
        },
      }}
    >
      {/* Background icon */}
      <Box sx={{
        position: 'absolute',
        top: { xs: 6, md: 10 },
        right: { xs: 6, md: 10 },
        color: color,
        opacity: 0.12,
        fontSize: { xs: 22, sm: 22, md: 32 },
      }}>
        {icon}
      </Box>

      <Typography sx={{
        color: '#2C3E50',
        fontSize: { xs: '10px', sm: '11px', md: '14px' },
        mb: { xs: '4px', md: '8px' },
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.7px',
      }}>
        {label}
      </Typography>

      <Typography sx={{
        color: '#1E293B',
        fontWeight: 700,
        fontSize: { xs: '22px', sm: '24px', md: '34px' },
        lineHeight: 1,
      }}>
        {value}
      </Typography>
    </Paper>
  );
};

export default StatCard;